import { Box } from "@material-ui/core";
import spinnerBoostRed from "../../assets/images/spinner-boost-red.gif";

const BoostSpinner = () => {
  return (
    <Box
      style={{
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        position: "fixed",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        zIndex: 1001,
        backgroundColor: "rgba(255, 255, 255, 0.67)",
      }}
    >
      <Box
        component="img"
        style={{
          height: "48px",
        }}
        src={spinnerBoostRed}
        alt="spinnerBoostRed"
      />
      {/* <CircularProgress ele disableShrink color="primary" /> */}
    </Box>
  );
};

export default BoostSpinner;
